import React from "react";
import { useNavigate } from "react-router-dom";

export default function Menu() {
  const navigate = useNavigate();

  let menu = [
    { name: "Create Review", link: "/createreview" },
    { name: "Reviews", link: "/reviews" },
    { name: "Estimates", link: "/estimates" },
    { name: "Random Bookings", link: "/bookings" },
    { name: "Booking Enquiries", link: "/bookingenquiries" },
    { name: "Direct Bookings", link: "/directbookings" },
    { name: "Image Labels", link: "/imagelabels" },
    { name: "Add Admin", link: "/adminaccess" },
    { name: "Admin for Packages", link: "/packagesadmin" },
  ];

  return (
    <>
      <div className="w-full">
        <h1 className="text-4xl text-center m-5">Main Menu</h1>
        <div className="grid grid-flow-col grid-rows-4 gap-1 w-4/5 mx-auto">
          {menu.map((item, index) => {
            return (
              <div key={item.name} className="w-60">
                <button
                  onClick={() => navigate(item.link)}
                  className="text-base w-full md:text-xl p-1 md:p-2 text-white bg-orange-400 hover:bg-orange-500 active:bg-orange-600"
                >
                  {index + 1}. {item.name}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
